<ngx-loading [show]="disableGrid" id="gridDisableDiv"></ngx-loading>
<ngx-loading [show]="loading"></ngx-loading>

<div class="container-fluid p-0">
  <!-- <div class="row mb-3"> -->
  <div class="row">
    <!--Confirmations-->
    <div class="col">
      <div class="section-header">Appointment Confirmations</div>
      <div class="border p-2 light-grey-background">
        <!--Scheduled Confirmation-->
        <ng-container *ngIf="confirmScheduledSettings">
          <div class="row mx-0 mb-2">
            <h6 class="col-2 m-0 p-0 d-flex align-items-center teal-font">
              <i class="far fa-calendar-check mr-2"></i>Scheduled
            </h6>
            <div class="col-1 p-0 d-flex align-items-center teal-font">
              <label class="p-0 switch">
                <input
                  type="checkbox"
                  [(ngModel)]="confirmScheduledSettings.enabled"
                  (change)="updateEmailNotification(confirmScheduledSettings)"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="col p-0">
              <button
                type="button"
                class="btn btn-medium em-btn em-btn-green py-1"
                (click)="viewEmailTemplate(confirmScheduledSettings)"
              >
                View Email Template
              </button>
            </div>
          </div>
          <div class="mb-2 mr-2 teal-font">
            <span>Send Email When Appointment Scheduled</span>
          </div>
        </ng-container>
        <!--Changed Confirmation-->
        <ng-container *ngIf="confirmChangedSettings">
          <div class="row mx-0 mb-2">
            <h6 class="col-2 m-0 p-0 d-flex align-items-center teal-font">
              <i class="far fa-calendar-edit mr-2"></i>Changed
            </h6>
            <div class="col-1 p-0 d-flex align-items-center teal-font">
              <label class="p-0 switch">
                <input
                  type="checkbox"
                  [(ngModel)]="confirmChangedSettings.enabled"
                  (change)="updateEmailNotification(confirmChangedSettings)"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="col p-0">
              <button
                type="button"
                class="btn btn-medium em-btn em-btn-green py-1"
                (click)="viewEmailTemplate(confirmChangedSettings)"
              >
                View Email Template
              </button>
            </div>
          </div>
          <div class="mb-2 mr-2 teal-font">
            <span>Send Email When Appointment Changed</span>
          </div>
        </ng-container>
        <!--Cancelled Confirmation-->
        <ng-container *ngIf="confirmCancelledSettings">
          <div class="row mx-0 mb-2">
            <h6 class="col-2 m-0 p-0 d-flex align-items-center teal-font">
              <i class="far fa-calendar-times mr-2"></i>Cancelled
            </h6>
            <div class="col-1 p-0 d-flex align-items-center teal-font">
              <label class="p-0 switch">
                <input
                  type="checkbox"
                  [(ngModel)]="confirmCancelledSettings.enabled"
                  (change)="updateEmailNotification(confirmCancelledSettings)"
                />
                <span class="slider round"></span>
              </label>
            </div>
            <div class="col p-0">
              <button
                type="button"
                class="btn btn-medium em-btn em-btn-green py-1"
                (click)="viewEmailTemplate(confirmCancelledSettings)"
              >
                View Email Template
              </button>
            </div>
          </div>
          <div class="mb-2 mr-2 teal-font">
            <span>Send Email When Appointment Cancelled</span>
          </div>
        </ng-container>
      </div>
    </div>
    <!--Visit Reminders-->
    <div class="col">
      <ng-container
        *ngTemplateOutlet="
          reminderSettings;
          context: { title: 'Visit', emailSettings: visitEmailSettings, smsSettings: visitSmsSettings }
        "
      ></ng-container>
    </div>
    <!--Form Reminders-->
    <!-- <div class="col">
      <ng-container
        *ngTemplateOutlet="
          reminderSettings;
          context: { title: 'Form', emailSettings: formEmailSettings, smsSettings: formSmsSettings }
        "
      ></ng-container>
    </div> -->
  </div>
  <!-- <div class="row"> -->
  <!--Credit Card Reminders-->
  <!-- <div class="col">
      <ng-container
        *ngTemplateOutlet="
          reminderSettings;
          context: { title: 'Credit Card', emailSettings: ccEmailSettings, smsSettings: ccSmsSettings }
        "
      ></ng-container>
    </div>
  </div> -->

  <p-overlayPanel #hoverPanel id="hoverPanel" [dismissable]="false"></p-overlayPanel>
  <app-actionpanel></app-actionpanel>
</div>

<ng-template #reminderSettings let-title="title" let-emailSettings="emailSettings" let-smsSettings="smsSettings">
  <div class="section-header">{{ title }} Reminders</div>
  <div class="border p-2 light-grey-background">
    <!--Email-->
    <div class="mb-2 d-flex align-items-center">
      <h6 class="m-0 teal-font"><i class="far fa-envelope mr-2"></i>Email</h6>
      <div class="ml-3 d-flex align-items-center teal-font bigger" *ngIf="emailSettings">
        <label class="switch">
          <input
            type="checkbox"
            [(ngModel)]="emailSettings.enabled"
            (change)="updateEmailNotification(emailSettings)"
            [disabled]="!emailSettings.enabled && (!emailSettings?.emailJson || !emailSettings?.emailHtml)"
          />
          <span class="slider round"></span>
        </label>
        <span class="pl-2">Send Email {{ title }} Reminders</span>
        <span
          *ngIf="!emailSettings?.emailJson || !emailSettings?.emailHtml"
          class="pl-2 calendar-red-font"
          kendoTooltip
          title="{{ title }} reminders will not be sent. Edit to set up an email template."
          ><i class="fas fa-exclamation-circle"></i> No Email Template Set</span
        >
      </div>
    </div>
    <div class="card mb-2">
      <div class="card-body">
        <div class="mb-3 d-flex justify-content-between">
          <div class="mr-2">
            <div class="teal-font mb-1">Email Subject</div>
            <div class="medium">
              {{ emailSettings?.emailSubjectLine ? emailSettings?.emailSubjectLine : '-' }}
            </div>
          </div>
          <button
            type="button"
            class="btn btn-medium em-btn em-btn-green py-1 my-2 ml-auto"
            (click)="navigateToEditEmailReminderPanel(emailSettings)"
          >
            Edit
          </button>
          <!--<button
                type="button"
                class="btn btn-medium em-btn em-btn-green py-1 my-2 ml-2"
                (click)="navigateToSendTestVisitReminderPanel('email')"
              >
                Send Test
              </button> -->
        </div>
        <div class="mb-3">
          <div class="teal-font mb-1">Sender Name</div>
          <div class="medium">
            {{ emailSettings?.senderName ? emailSettings?.senderName : '-' }}
          </div>
        </div>
        <div class="mb-3">
          <div class="teal-font mb-1">Sender Email</div>
          <div class="medium">
            {{ emailSettings?.senderEmail ? emailSettings?.senderEmail : '-' }}
          </div>
        </div>
        <div class="pt-3 grey-three-border-top">
          <div class="teal-font mb-1">When to Send</div>
          <div
            *ngIf="emailSettings?.firstNotificationBefore || emailSettings?.repeatNotificationEvery; else nonConfigured"
            class="medium"
          >
            Send email
            <strong
              ><u>{{ emailSettings?.firstNotificationBefore }}</u></strong
            >
            before scheduled visit
            <ng-container *ngIf="emailSettings?.repeatNotificationEvery">
              , every
              <strong
                ><u>{{ emailSettings?.repeatNotificationEvery }}</u></strong
              >
              until visit is confirmed
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <!--SMS-->
    <div class="mb-2 d-flex align-items-center">
      <h6 class="m-0 teal-font"><i class="far fa-comment-dots mr-2"></i>SMS</h6>
      <div class="ml-3 d-flex align-items-center teal-font bigger" *ngIf="smsSettings">
        <label class="switch">
          <input
            *ngIf="clinicsService.isTwilioEnabled"
            type="checkbox"
            [(ngModel)]="smsSettings.enabled"
            (change)="updateSmsNotification(smsSettings)"
          />
          <input *ngIf="!clinicsService.isTwilioEnabled" type="checkbox" disabled [ngModel]="false" />
          <span class="slider round"></span>
        </label>
        <span class="pl-2"
          >Send Sms {{ title }} Reminders
          <i
            *ngIf="!clinicsService.isTwilioEnabled"
            kendoTooltip
            [tooltipTemplate]="disabledSmsTemplate"
            filter="i"
            position="right"
            class="fa fa-exclamation-circle teal-font ml-1"
          ></i>
          <ng-template #disabledSmsTemplate> This clinic does not have SMS messaging enabled. </ng-template>
        </span>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="mb-3 d-flex justify-content-between">
          <div class="mr-2">
            <div class="teal-font mb-1">SMS Title</div>
            <div class="medium">{{ smsSettings?.title ? smsSettings?.title : '-' }}</div>
          </div>
          <button
            type="button"
            class="btn btn-medium em-btn em-btn-green py-1 my-2 ml-auto"
            (click)="navigateToEditSmsReminderPanel()"
          >
            Edit
          </button>
          <button
            class="btn btn-medium em-btn em-btn-green py-1 my-2 ml-2"
            type="button"
            (click)="navigateToSendTestVisitReminderPanel('sms')"
          >
            Send Test
          </button>
        </div>
        <div class="mb-3">
          <div class="teal-font mb-1">SMS Message</div>
          <div class="medium" [innerHTML]="smsSettings?.message ? smsSettings?.messageWithLineBreaks : '-'"></div>
        </div>
        <div class="pt-3 grey-three-border-top">
          <div class="teal-font mb-1">When to Send</div>
          <div
            *ngIf="smsSettings?.firstNotificationBefore || smsSettings?.repeatNotificationEvery; else nonConfigured"
            class="medium"
          >
            Send SMS
            <strong
              ><u>{{ smsSettings?.firstNotificationBefore }}</u></strong
            >
            before scheduled visit
            <ng-container *ngIf="smsSettings?.repeatNotificationEvery">
              , every
              <strong
                ><u>{{ smsSettings?.repeatNotificationEvery }}</u></strong
              >
              until visit is confirmed
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #nonConfigured>
  <div class="medium">Please configure schedule</div>
</ng-template>
